import { useState, useContext } from 'react';
import { Typography } from '@mui/material';
import {
  Public as WebIcon,
  Instagram as InstagramIcon,
  Facebook as FacebookIcon
} from '@mui/icons-material';

import SmartForm from '@component/smartForm/SmartForm';
import SmartTextInput from '@component/smartForm/SmartInputText';
import SmartTextareaInput from './smartForm/SmartTextareaInput';
import SmartLinkInput from './smartForm/SmartLinkInput';
import SmartImageUpload from './smartForm/SmartImageUpload';
import SmartContainer from './smartForm/SmartContainer';

import { useTranslation } from "react-i18next";

import { AccountContext } from "@context/AccountProvider";
import { AlertContext } from "@context/AlertProvider";

import { useQueryClient } from "@tanstack/react-query";
import { useClubUpdateMutation } from "@mutation/clubMutation";

const ClubForm = () => {
  const { club } = useContext(AccountContext);
  const [formModel, setFormModel] = useState(club)
  const { addAlertBanner } = useContext(AlertContext);
  const { t } = useTranslation(["main", "error"]);

  const queryClient = useQueryClient();
  const clubUpdateMutation = useClubUpdateMutation(club.uuid);

  const handleSave = (newModel) => {
    clubUpdateMutation.mutate(
      { data: {file_image_uuid: newModel.file_image.uuid, ...newModel} },
      {
        onSuccess: () => {
            addAlertBanner(t("main:saveSuccess"), "success", 4000);
            queryClient.invalidateQueries({ queryKey: ["club"] });
        },
        onError: (error) => {
            if (!error.response) {
                addAlertBanner(t("error:networkError"), "error", 4000);
                return;
            }

            const statusCode = error.response.status;

            if (statusCode === 403) {
            addAlertBanner(t("error:noModificationPrivileges"), "error", 5000);
            } else if (statusCode === 404) {
            addAlertBanner(t("error:notFound"), "error", 4000);
            } else if (statusCode === 400) {
            addAlertBanner(t("error:validationError"), "error", 5000);
            } else if (statusCode === 422) {
            addAlertBanner(t("error:validationError"), "error", 5000);
            } else if (statusCode >= 500) {
            addAlertBanner(t("error:serverError"), "error", 4000);
            } else {
            addAlertBanner(t("error:somethingGoesWrong"), "error", 4000);
            }
        }
      }
    );
  };

  const handleCancel = (oldModel) => {
    console.log('Reverted to:', oldModel);
  };

  const handleEdit = () => {
    console.log('Entered edit mode');
  };

  return (
    <SmartForm
      // model={club}
      formModel={formModel}
      setFormModel={setFormModel}
      onSave={handleSave}
      onCancel={handleCancel}
      onEdit={handleEdit}
      buttonPanelSx={{
          top: "10px",
          right: "10px",
          zIndex: "drawer" // beacuse of sidebar
      }}
    >
      <SmartImageUpload field="file_image.uuid" />

      <SmartTextInput 
        field="name" 
        label="Club Name"
        renderView={(value) => (
          <Typography variant="h3" align="center" sx={{ fontWeight: 500 }}>
            {value || 'Untitled Club'}
          </Typography>
        )}
      />
      
      <SmartTextareaInput field="description" label={t("main:description")} rows={10} />

      <SmartContainer 
        title={t("main:socials")}
        contentSx={{ 
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'start'
        }}
      >
        <SmartLinkInput field="web_url" icon={WebIcon} emptyLinkValue=""/>
        <SmartLinkInput field="instagram_url" icon={InstagramIcon} emptyLinkValue=""/>
        <SmartLinkInput field="facebook_url" icon={FacebookIcon} emptyLinkValue=""/>
      </SmartContainer>

    </SmartForm>
  );
};

export default ClubForm;